// Thin wrapper over the Umami tracker loaded in index.html. No-op if Umami hasn't
// loaded (deferred script, blocked by an ad-blocker, SSR) — analytics must never
// break the app.

interface Umami {
  track: (event: string, data?: Record<string, unknown>) => void;
}

declare global {
  interface Window {
    umami?: Umami;
  }
}

/** Fire a custom Umami event. Safe to call anywhere; silently does nothing when
 * the tracker isn't available. */
export function trackEvent(event: string, data?: Record<string, unknown>): void {
  try {
    window.umami?.track(event, data);
  } catch {
    /* never let analytics throw into app code */
  }
}
